import Vue from 'vue'
import { pgMessage, pgMessageBox } from '../components/index'

/***
 * 处理提示信息
 * type: 'message/messageBox'
 * msg: 提示内容
 */
const messageMethod = function (type, res) {
  switch (type) {
    case 'message':
      if (res?.code === 200) {
        pgMessage.success(res?.msg ?? '成功')
      } else {
        pgMessage.error(res?.msg ?? '失败')
      }
      break
    case 'messageBox':
      pgMessageBox({
        message: res?.msg ?? '失败',
      })
      break
  }
}

/**
 * originalData 原始接口返回的data属性
 */
const progressTaskMethod = async function (progressTask, config, originalData) {
  const { successTip, errorTip, doingCallback, ...axiosConfig } = config
  if (progressTask.status?.code === 'WAIT' || progressTask.status?.code === 'DOING') {
    if (progressTask.status?.code === 'DOING') doingCallback?.(progressTask)
    return new Promise((resolve) => {
      setTimeout(async () => {
        const requestConfig = Object.assign(
          {
            method: 'get',
            url: 'rest/main/progressTask/getAndClearCompleteCache',
            params: { id: progressTask.id },
          },
          axiosConfig
        )
        const res = await Vue.prototype.$axios(requestConfig).catch((error) => error)
        if (res.data) {
          const resData = res.data
          if (resData.code === 200) {
            resolve(progressTaskMethod(resData.data, config, originalData))
          } else {
            messageMethod(errorTip, resData)
            resolve([null, resData])
          }
        } else {
          const errorRes = { msg: res }
          messageMethod(errorTip, errorRes)
          resolve([null, errorRes])
        }
      }, 1000)
    })
  } else if (progressTask.status?.code === 'COMPLETE') {
    if (progressTask.type === 'CUSTOM_DATA') {
      const resData = JSON.parse(progressTask.data)
      resData.originalData = originalData
      if (resData.code === 200) {
        messageMethod(successTip, resData)
        return [resData, null]
      } else {
        messageMethod(errorTip, resData)
        return [null, resData]
      }
    } else {
      const resData = { ...progressTask, code: 200, msg: progressTask.message, originalData }
      messageMethod(successTip, resData)
      return [resData, null]
    }
  } else {
    const resData = { ...progressTask, code: 400, msg: progressTask.message }
    messageMethod(errorTip, resData)
    return [null]
  }
}

/***
 * config是axios中的配置，额外新增了几个用于判断提示
 * successTip: 'message/messageBox' 默认值为 null
 * errorTip: 'message/messageBox' 默认值为 'messageBox'
 * doingCallback: 存在异步任务时，状态是DONING的回调
 */
const request = async function (config, callback) {
  const { successTip, errorTip = 'messageBox', doingCallback, ...axiosConfig } = config
  const res = await Vue.prototype.$axios(axiosConfig).catch((error) => error)
  if (res.data) {
    const resData = callback ? callback(res.data, res) : res.data
    if (resData.progressTask) {
      return progressTaskMethod(
        resData.progressTask,
        { successTip, errorTip, doingCallback },
        resData.data
      )
    } else if (resData.code === 200) {
      messageMethod(successTip, resData)
      return [resData, null]
    } else {
      messageMethod(errorTip, resData)
      return [null, resData]
    }
  } else {
    const errorRes = { msg: res }
    messageMethod(errorTip, errorRes)
    return [null, errorRes]
  }
}

const get = function (url, params, otherConfig, callback) {
  const config = {
    url,
    method: 'get',
    params,
    ...otherConfig,
  }
  return request(config, callback)
}

const post = function (url, data, otherConfig, callback) {
  const config = {
    url,
    method: 'post',
    data,
    ...otherConfig,
  }
  return request(config, callback)
}

const http = {
  get,
  post,
}

export { request, get, post, http }
